import { rest } from 'msw';
import config from '@config';
import teamStatsMockData from '../../../../features/widget-team-stats/fixtures/data.json';

const baseUrl = config.hosts.gridApi;

const getTeamStats = rest.get(
    `${baseUrl}/stats-feed-gateway/widgets/predefined-team-stats`,
    (req, res, ctx) => res(ctx.json(teamStatsMockData)),
);

export default [getTeamStats];
